import { render, staticRenderFns } from "./qoqBox.vue?vue&type=template&id=64a14790&scoped=true&"
import script from "./qoqBox.vue?vue&type=script&lang=js&"
export * from "./qoqBox.vue?vue&type=script&lang=js&"
import style0 from "./qoqBox.vue?vue&type=style&index=0&id=64a14790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a14790",
  null
  
)

export default component.exports